import React from "react";


interface NotificationCenterProps {
    notifications: Array<{
      id: string;
      type: string;
      timestamp: Date;
      message: string;
      read: boolean;
    }>;
    isOpen: boolean;
    onClose: () => void;
    onClearAll: () => void;
    onReadNotification: (id: string) => void;
}
export const NotificationCenter = ({ notifications, isOpen, onClose, onClearAll, onReadNotification }:NotificationCenterProps) => {
    return (
      <div className={`notification-center ${isOpen ? "open" : ""}`} onClick={e => e.stopPropagation()}>
        <div className="notification-header">
          <div className="notification-title">Notifications</div>
          {notifications.length > 0 && (
            <button className="clear-all" onClick={onClearAll}>
              Mark all as read
            </button>
          )}
        </div>
        
        <div className="notification-list">
          {notifications.length === 0 ? (
            <div className="notification-empty">
              No notifications
            </div>
          ) : (
            notifications.map(notification => (
              <NotificationItem 
                key={notification.id}
                notification={notification}
                onRead={() => onReadNotification(notification.id)}
              />
            ))
          )}
        </div>
      </div>
    );
  };

  interface NotificationItemProps {
    notification: {
      id: string;
      type: string;
      timestamp: Date;
      message: string;
      read: boolean;
    };
    onRead: () => void;
  }
  
  // Notification Item Component
  const NotificationItem = ({ notification, onRead }:NotificationItemProps) => {
    const { type, timestamp, message, read } = notification;
    
    // Calculate time ago
    const getTimeAgo = (date:Date) => {
      const seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);
      
      let interval = Math.floor(seconds / 31536000);
      if (interval > 1) return `${interval} years ago`;
      
      interval = Math.floor(seconds / 2592000);
      if (interval > 1) return `${interval} months ago`;
      
      interval = Math.floor(seconds / 86400);
      if (interval > 1) return `${interval} days ago`;
      
      interval = Math.floor(seconds / 3600);
      if (interval > 1) return `${interval} hours ago`;
      
      interval = Math.floor(seconds / 60);
      if (interval > 1) return `${interval} minutes ago`;
      
      return `${Math.floor(seconds)} seconds ago`;
    };
    
    // Get icon based on notification type
    const getIcon = () => {
      switch(type) {
        case "sign_in":
          return { 
            bg: "var(--apple-light-green)", 
            color: "var(--apple-green)",
            icon: "→"
          };
        case "sign_out":
          return { 
            bg: "var(--apple-light-orange)", 
            color: "var(--apple-orange)",
            icon: "←"
          };
        default:
          return { 
            bg: "var(--apple-light-blue)", 
            color: "var(--apple-blue)",
            icon: "i"
          };
      }
    };
    
    const iconStyle = getIcon();
    
    return (
      <div 
        className="notification-item" 
        style={{ backgroundColor: read ? "transparent" : "rgba(0, 113, 227, 0.05)" }}
        onClick={onRead}
      >
        <div 
          className="notification-icon"
          style={{ backgroundColor: iconStyle.bg, color: iconStyle.color }}
        >
          {iconStyle.icon}
        </div>
        <div className="notification-content">
          <div className="notification-message">{message}</div>
          <div className="notification-time">{getTimeAgo(timestamp)}</div>
          {!read && (
            <div className="notification-action">Mark as read</div>
          )}
        </div>
      </div>
    );
  };